/**
 * Public store listings. The iOS record is currently distributed through the
 * Central American storefronts; the regional URL resolves where Apple's
 * generic `/app/id...` short URL still returns 404.
 */
export const IOS_APP_STORE_URL = 'https://apps.apple.com/sv/app/id6797718483'

export const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=app.tago.rent'
